import { FormattedMessage, useIntl } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import { Body } from './body';
import { Footer } from './footer';
import ModalPortal from '../../../../../../components/modal-portal';

import { messages } from './messages';

type EditAddressModalProps = {
  onClose: () => void;
};

export const EditAddressModal = ({ onClose }: EditAddressModalProps) => {
  const { formatMessage } = useIntl();

  return (
    <ModalPortal onClose={onClose}>
      <Modal modalHeaderId={formatMessage(messages.modalAriaLabel)} size='medium'>
        <ModalHeader>
          <FormattedMessage {...messages.modalTitle} />
        </ModalHeader>
        <Body />
        <Footer onClose={onClose} />
      </Modal>
    </ModalPortal>
  );
};
